import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import { theme } from '../../../tailwind.config';
var AddFieldButton = function AddFieldButton(_ref) {
  var dataTestElement = _ref['data-test-element'],
    isPositioned = _ref.isPositioned,
    label = _ref.label,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: isPositioned ? 'absolute top-0 right-0' : ''
  }, /*#__PURE__*/React.createElement("button", {
    className: "flex itmes-center",
    type: "button",
    onClick: onClick,
    "data-test-element": dataTestElement
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "V2Add",
    color: theme.extend.colors['current-blue']
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-current-blue pl-1 transform -translate-y-px"
  }, label)));
};
AddFieldButton.defaultProps = {
  'data-test-element': null,
  isPositioned: false,
  onClick: function onClick() {
    return null;
  }
};
AddFieldButton.propTypes = {
  'data-test-element': PropTypes.string,
  isPositioned: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
export default AddFieldButton;
//# sourceMappingURL=ButtonAddField.js.map